import { render } from "./IndexDefault.vue?vue&type=template&id=b1594db4&scoped=true"
import script from "./IndexDefault.vue?vue&type=script&lang=js"
export * from "./IndexDefault.vue?vue&type=script&lang=js"

import "./IndexDefault.vue?vue&type=style&index=0&id=b1594db4&scoped=true&lang=css"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1594db4"]])

export default __exports__